import { h, Component } from "preact";
import styles from "./style.module.scss";

import RightIcon from "../icon/RightIcon";
import ClearIcon from "../icon/ClearIcon";
import SubmitIcon from "../icon/SubmitIcon";

// import SectionTitle from '../base/SectionTitle';
// import { CopyToClipboard } from "react-copy-to-clipboard";
// import ButterToast, { Cinnamon, POS_TOP, POS_CENTER } from 'butter-toast';

import { postTranslate } from "../../utils/apiCalls";

const groupBy = (xs, f) => {
  //return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
  return xs.reduce(
    (r, v, i, a, k = f(v) === "constructor" ? f(v) + "." : f(v)) => (
      (r[k] || (r[k] = [])).push(v), r
    ),
    {}
  );
};

const process = {
  env: { URL: "https://www.wordyguru.com" }
};

class TranslateBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      translateText: "",
      lang: props.lang ? props.lang : "th",
      isTranslated: false,
      resultRelateds: [],
      from: "",
      to: ""
    };

    this.translate = [];
  }

  handleChange = event => {
    const text = event.target.value;
    this.setState({ text });
    var from = "";
    var to = "";
    if (event.target.value !== "") {
      from = "en";
      to = "th";
      var thai =
        "[ๅภถุึคตจขชๆไำพะัีรนยบลฃฟหกดเ้่าสวงผปแอิืทมใฝ๑๒๓๔ู฿๕๖๗๘๙๐ฎฑธํ๊ณฯญฐฅฤฆฏโฌ็๋ษศซฉฮฺ์ฒฬฦ]+";
      //var english = /[^A-Za-z0-9\.,\?""!@#\$%\^&\*\(\)-_=\+;:<>\/\\\|\}\{\[\]`~]*$/;
      var patt = new RegExp(thai, "g");
      if (patt.test(text)) {
        from = "th";
        to = "en";
      }
    }
    this.setState({ from: from, to: to });
  };

  handleSubmit = async event => {
    if (!this.state.text) {
      return;
    }
    if (event) {
      event.preventDefault();
    }

    const { from, to, text } = this.state;

    this.setState({
      isTranslated: true,
      translateText: "",
      resultRelateds: {}
    });

    var res = await postTranslate(from, to, text, true);
    if (res.status && res.status !== 200) {
      res.result = "";
    }

    var groupRelated = {};
    if (res && res.relateds) {
      const resultRelateds = groupBy(res.relateds, c => c.app_id);
      for (var key in resultRelateds) {
        if (resultRelateds.hasOwnProperty(key)) {
          if (key === 27) {
            var tmp = groupBy(resultRelateds[key], c => c.line_three);
            groupRelated[key] = tmp;
          } else {
            var tmp = groupBy(resultRelateds[key], c => c.line_one);
            groupRelated[key] = tmp;
          }
        }
      }
    }

    this.setState(
      {
        translateText: res.result ? res.result : "",
        resultRelateds: groupRelated
      },
      () => {
        var that = this;
        setTimeout(function() {
          that.translate.focus();
        }, 100);
      }
    );
  };

  onCopyClick(text, title, content) {
    if (text) {
      // ButterToast.raise({
      //   content: (
      //     <Cinnamon.Crisp
      //       scheme={Cinnamon.Crisp.SCHEME_GREY}
      //       content={content}
      //       title={title}
      //     />
      //   )
      // });
    }
  }

  createTable = wordGroup => {
    let list = [];
    Object.keys(wordGroup).map(key => {
      //find top word of group
      let index = 0;
      var l3Key = Object.keys(wordGroup[key])[0];
      var word = wordGroup[key][l3Key][0];
      list.push(
        <tr key={`trtt${key}`}>
          <td colSpan="3" class={styles.nobd}>
            <h3>
              {key === "27" ? `ความหมายของ ${word.line_one}` : word.app_name}
            </h3>
          </td>
        </tr>
      );
      Object.keys(wordGroup[key]).map(inkey => {
        inkey !== "null" &&
          list.push(
            <tr key={`trl3${key}${inkey}`}>
              <td colSpan="3" class={styles[`category`]}>
                <h4 class="sub-title is-uppercase is-size-7">{inkey}</h4>
              </td>
            </tr>
          );
        wordGroup[key][inkey].map(word => {
          if (key !== "27") {
            list.push(
              <tr key={`trl1${word.id}`}>
                <td class={styles[`text-grey`]}>
                  <p>{++index}</p>
                </td>
                <td>
                  <div>
                    <p class="is-capitalized is-size-6">{word.line_one}</p>
                    {word.line_two && (
                      <p class={styles[`text-grey`]}>{word.line_two}</p>
                    )}
                    {word.line_three && (
                      <p class={styles[`text-grey`]}>{word.line_three}</p>
                    )}
                    {word.line_four && (
                      <p class={styles[`text-grey`]}>{word.line_four}</p>
                    )}
                    {word.line_five && (
                      <p class={styles[`text-grey`]}>{word.line_five}</p>
                    )}
                    {word.note && (
                      <p class={styles[`text-grey`]}>{word.note}</p>
                    )}
                  </div>
                </td>
                <td>
                  <a
                    target="_blank"
                    rel="nofollow"
                    href={`${process.env.URL}/a/${word.app_slug}/q/${word.slug}`}
                    class="link"
                  >
                    <RightIcon />
                  </a>
                </td>
              </tr>
            );
          } else {
            list.push(
              <tr key={`trl1${word.id}`}>
                <td class={styles[`text-grey`]}>
                  <p>{++index}</p>
                </td>
                <td>
                  <div>
                    {word.line_two && (
                      <p class="is-capitalized is-size-6">{word.line_two}</p>
                    )}
                    {word.line_four && (
                      <p class={styles[`text-grey`]}>{word.line_four}</p>
                    )}
                    {word.line_five && (
                      <p class={styles[`text-grey`]}>{word.line_five}</p>
                    )}
                    {word.note && (
                      <p class={styles[`text-grey`]}>{word.note}</p>
                    )}
                  </div>
                </td>
                <td>
                  <a
                    target="_blank"
                    rel="nofollow"
                    href={`${process.env.URL}/a/${word.app_slug}/q/${word.slug}`}
                    class="link"
                  >
                    <RightIcon />
                  </a>
                </td>
              </tr>
            );
          }
        });
      });
      list.push(
        <tr key={`trtb${key}`}>
          <td class={styles[`nobd`]}></td>
          <td class={styles[`nobd`]} colspan="2">
            <br />
          </td>
        </tr>
      );
    });

    return list;
  };

  render(props, state) {
    return (
      <div class="">
        <div class={styles[`main-translate-box`]}>
          <div class={styles[`translate-box`]}>
            <div class={styles[`translate-box__input-box`]}>
              <div class={styles[`translate-box__input`]}>
                <p class={styles[`translate-box__lang`]}>
                  {state.from === ""
                    ? `ภาษาต้นทาง`
                    : state.from === "th"
                    ? "ภาษาไทย"
                    : "English"}
                  <span>
                    {state.from === ""
                      ? `ตรวจอัตโนมัติ`
                      : state.from === "en"
                      ? "ภาษาไทย"
                      : "English"}
                  </span>
                </p>
                <textarea
                  class={styles[`source`]}
                  placeholder={
                    state.lang === "th"
                      ? "พิมพ์ ภาษาไทย หรือ ภาษาอังกฤษ หรือกดปุ่มวางข้อความ แล้วกดปุ่มเพื่อทำการแปล"
                      : "Type a text or paste text here to translate"
                  }
                  onInput={e => this.handleChange(e)}
                  value={state.text}
                />
                {state.text.length > 0 && (
                  <button
                    class={styles[`clear`]}
                    onClick={() =>
                      this.setState({ text: "", translateText: "" })
                    }
                  >
                    <ClearIcon />
                  </button>
                )}
                <button
                  class={state.text.length > 0 ? styles[`active`] : ""}
                  onClick={e => this.handleSubmit(e)}
                >
                  <SubmitIcon />
                </button>
              </div>
              <div class={styles[`translate-box__panel`]}>
                <ul>
                  {/* <li>
                    <CopyToClipboard
                      text={state.text}
                      onCopy={() =>
                        this.onCopyClick(
                          state.text,
                          "Copied!",
                          "คัดลอกเรียบร้อย"
                        )
                      }
                    >
                      <button class={state.text.length > 0 ? "active" : ""}>
                        <img src={`/static/assets/icon/icon-copy-p24.png`} />{" "}
                        คัดลอก
                      </button>
                    </CopyToClipboard>
                  </li> */}
                  {/* <li>
                    <button
                      class={state.text.length > 0 ? "active" : ""}
                      onClick={() =>
                        this.setState({ text: "", translateText: "" })
                      }
                    >
                      <ClearIcon /> ล้างข้อความ
                    </button>
                  </li> */}
                  {/* <li>
                    <button class="active">
                      <img src={`/static/assets/icon/icon-paste-p24.png`} /> วาง
                    </button>
                  </li> */}
                  {/* <li>
                <button
                class=""
              >
                <img src={`/static/assets/icon/icon-speak-p24.png`} /> เสียงอ่าน
              </button>
              </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div class={styles[`translate-box`]}>
            <div class={styles[`translate-box__input-box`]}>
              <div class={styles[`translate-box__input`]}>
                <p class={styles[`translate-box__lang`]}>
                  {state.to === ""
                    ? `คำแปล`
                    : state.to === "th"
                    ? "ภาษาไทย"
                    : "English"}
                  <span>
                    {state.to === ""
                      ? `ตรวจอัตโนมัติ`
                      : state.to === "en"
                      ? "ภาษาไทย"
                      : "English"}
                  </span>
                </p>
                <textarea
                  ref={ele => (this.translate = ele)}
                  value={state.translateText}
                  readOnly={true}
                  placeholder={state.text && state.text.length > 0 ? "..." : ""}
                />
              </div>
              <div class={styles[`translate-box__panel`]}>
                <ul>
                  {/* <li>
                    <CopyToClipboard
                      text={state.translateText}
                      onCopy={() =>
                        this.onCopyClick(
                          state.translateText,
                          "Copied!",
                          "คัดลอกเรียบร้อย"
                        )
                      }
                    >
                      <button
                        class={
                          state.translateText.length > 0 ? "active" : ""
                        }
                      >
                        <img src={`/static/assets/icon/icon-copy-p24.png`} />{" "}
                        คัดลอก
                      </button>
                    </CopyToClipboard>
                  </li> */}
                  {/* <li>
                    <button class="active">
                      <img src={`/static/assets/icon/icon-share-p24.png`} />{" "}
                      แชร์
                    </button>
                  </li> */}
                  {/* <li>
                    <button class="">
                      <img
                        src={`/static/assets/icon/icon-favorite-p24.png`}
                      />{" "}
                      เก็บบันทึก
                    </button>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        </div>

        {Object.keys(state.resultRelateds).length > 0 && (
          <div>
            <div class={styles[`related-result`]}>
              <table>
                <tbody>{this.createTable(state.resultRelateds)}</tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default TranslateBox;



// WEBPACK FOOTER //
// ./components/translate-box/index.js